<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="修改产品信息"
      :visible.sync="visible"
      width="960px"
      top="10vh"
      class="relateOrder"
      :before-close="handleClose"
    >
      <div style="max-height: 69vh;overflow: auto;">
        <div class="table">
          <div class="table-list">
            <div class="item">
              <div class="content">
                <div class="left">
                  <img
                    :src="order.amazonPicUrl ? order.amazonPicUrl : noImage"
                    alt=""
                  />
                </div>
                <div class="right">
                  <div
                    :title="order.amazonProductName"
                    class="title text-ellipsis"
                    style="width: 350px;margin: 0 0 12px 0;"
                  >
                    {{ order.amazonProductName }}
                  </div>
                  <div class="list">
                    <div class="name">颜色</div>
                    <div class="value">
                      {{ order.color }}
                    </div>
                  </div>
                  <div class="list">
                    <div class="name">尺码</div>
                    <div class="value">
                      {{ order.size }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="content">
                <div class="left">
                  <img :src="mainPic ? mainPic : noImage" alt="" />
                </div>
                <div class="right">
                  <div class="list">
                    <div class="name">成品编号：</div>
                    <div class="value">
                      <el-input
                        v-model="currentOrderSku.designId"
                        class="input"
                        size="small"
                        @change="getTargetItem"
                        @keyup.enter="getTargetItem"
                        style="width:169px"
                      />
                      <el-button
                        size="small"
                        style="margin: 0 0 0 5px;"
                        @click="handleSelectDesign"
                        icon="el-icon-search"
                        circle
                      ></el-button>
                    </div>
                  </div>
                  <div class="sku-attr">
                    <div class="sku-name">颜色</div>
                    <div class="sku-detail">
                      <a
                        :style="{ background: dictMap['color'][color] }"
                        :class="{ 'is-select': currentAttr.color === color }"
                        @click="handleSelectColor(color)"
                        class="sku-color"
                        v-for="(color, index) in colorList"
                        :key="index"
                        :title="color"
                        style="width: 20px;height: 20px;display: inline-block;"
                      ></a>
                    </div>
                  </div>
                  <div class="sku-attr">
                    <div class="sku-name">尺码</div>
                    <div class="sku-detail">
                      <a
                        :class="{ 'is-select': currentAttr.size === size }"
                        @click="handleSelectSize(size)"
                        class="sku-size"
                        v-for="(size, index) in sizeList"
                        :key="index"
                        >{{ size }}</a
                      >
                    </div>
                  </div>
                  <div class="sku-attr">
                    <div class="sku-name">数量</div>
                    <div class="sku-detail">
                      <el-input
                        v-model="num"
                        class="input"
                        size="small"
                        width="100px"
                        maxlength="5"
                        onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取消</el-button>
        <el-button
          v-if="
            order.matchType === '01' &&
              order.amazonProductName !== null &&
              order.designId == null
          "
          type="primary"
          @click="handleSaveAndRelate"
          size="small"
        >
          保存并关联
        </el-button>
        <el-button
          v-if="
            order.amazonProductName !== null &&
              basicId == detail.basicId &&
              designId != detail.designId
          "
          type="primary"
          @click="handleSaveAndConvert"
          size="small"
        >
          保存并转换
        </el-button>
        <el-button type="primary" @click="handleSave" size="small">
          保存
        </el-button>
      </span>
    </el-dialog>
    <SelectDesign
      @onClose="handleCloseDesign"
      :visible="showSelect"
      @update="handleChooseDesign"
    ></SelectDesign>
  </div>
</template>

<script>
import { getCartInfo, getCartMatchInfo } from "@/api/customProduct/design"
import { editSku, changeSku, matchSku } from "@/api/order/all"
import noImage from "@/assets/images/no_image.png"
import { mapGetters } from "vuex"
import SelectDesign from "./SelectDesign"

export default {
  name: "ModifyOrder",
  data() {
    return {
      toMatch: {
        designId: "",
        picUrl: "",
        proName: "",
        attribute: "",
        num: "",
      },
      num: "",
      form: {
        appSkuId: "",
        skuId: "",
        num: "",
      },
      currentAttr: {
        color: "",
        size: "",
      },
      detail: {},
      attribute: {},
      mainPic: "",
      noImage: noImage,
      basicId: "",
      designId: "",
      showSelect: false,
    }
  },
  components: { SelectDesign },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    sizeList() {
      let sizeList = []
      if (this.detail.skuList) {
        for (let record of this.detail.skuList) {
          let color = record.properVal.split(":")[0]
          let size = record.properVal.split(":")[1]
          if (color == this.currentAttr.color) {
            if (!sizeList.includes(size)) {
              sizeList.push(size)
            }
          }
        }
      }
      return sizeList
    },
    colorList() {
      let colorList = []
      if (this.detail.skuList) {
        for (let record of this.detail.skuList) {
          let color = record.properVal.split(":")[0]
          if (!colorList.includes(color)) {
            colorList.push(color)
          }
        }
      }

      return colorList
    },
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    order: {
      type: Object,
      default() {
        return {}
      },
    },
    currentOrderSku: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.detail = this.currentOrderSku
          this.num = this.order.num
          this.form = {
            appSkuId: "",
            skuId: "",
          }
          if (this.currentOrderSku.attribute) {
            this.attribute = JSON.parse(this.currentOrderSku.attribute)
          } else {
            this.attribute = ""
          }
          if (this.order.properVal) {
            this.currentAttr.color = this.order.properVal.split(":")[0]
            this.currentAttr.size = this.order.properVal
              .split(":")[1]
              .replace(/\\/g, "")
            this.basicId = this.detail.basicId
            this.designId = this.detail.designId
            this.selectSku()
          } else {
            this.mainPic = ""
            this.currentAttr = {
              color: "",
              size: "",
            }
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getTargetItem(value) {
      try {
        let result = await getCartMatchInfo(value)
        if (result.data.length > 0) {
          this.detail = result.data[0]
          this.attribute = JSON.parse(result.data[0].attribute)
          let sku = this.detail.skuList[0]

          this.currentAttr = {
            color: sku.properVal.split(":")[0],
            size: sku.properVal.split(":")[1],
          }
          this.selectSku()
        } else {
          this.detail = {}
          this.attribute = {}
          this.form.skuId = ""
          this.msgError("没有匹配的商品")
          this.currentAttr = {
            color: "",
            size: "",
          }
        }
      } catch (error) {
        this.detail = {}
        this.attribute = {}
      }
    },
    changeProper(data, index, item) {
      let skuId = ""
      let pId = ""
      let properName = ""
      const properVal0 = item.properVal.split(":")[0]
      const properVal1 = item.properVal.split(":")[1]
      let newProperVal = ""

      if (index === 0) {
        newProperVal = data + ":" + properVal1
      }

      if (index === 1) {
        newProperVal = properVal0 + ":" + data
      }

      this.currentOrderSku.skuList.map((el) => {
        if (el.properVal === newProperVal) {
          skuId = el.skuId
          pId = el.pId
          properName = el.properName
        }
      })

      item.properVal = newProperVal
      item.skuId = skuId
      item.properName = properName
      item.pId = pId
    },
    sure() {
      this.form.appSkuId = this.order.appSkuId
      if (this.form.skuId === "") {
        this.$message.error("请选择需要关联的产品")
        return
      }
      matchSku(this.form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("关联成功")
            this.$emit("onClose")
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    handleClose() {
      this.$emit("onClose")
    },
    handleSelectColor(color) {
      this.currentAttr.color = color
      this.selectSku()
    },
    handleSelectSize(size) {
      this.currentAttr.size = size
      this.selectSku()
    },
    selectSku() {
      for (let record of this.detail.skuList) {
        record.properVal = record.properVal.replace(/\\/g, "")
        if (
          record.properVal ===
          `${this.currentAttr.color}:${this.currentAttr.size}`
        ) {
          this.form.skuId = record.skuId
          this.mainPic = record.picList[0].picUrl
          break
        }
      }
    },
    async handleSaveAndConvert() {
      this.form.num = this.num
      this.form.appSkuId = this.order.appSkuId
      if (this.form.skuId === "") {
        this.$message.error("请选择需要关联的产品")
        return
      }
      if (this.form.num.trim() === "") {
        this.$message.error("请填写数量")
        return
      }
      //转换SKU
      await changeSku(this.form)
      this.$message.success("保存成功")
      this.$emit("onClose")
    },
    async handleSaveAndRelate() {
      this.form.num = this.num
      this.form.appSkuId = this.order.appSkuId

      if (this.form.skuId === "") {
        this.$message.error("请选择需要关联的产品")
        return
      }
      if (this.form.num.trim() === "") {
        this.$message.error("请填写数量")
        return
      }
      await matchSku(this.form)
      this.$message.success("保存成功")
      this.$emit("onClose")
    },
    async handleSave() {
      this.form.num = this.num
      this.form.appSkuId = this.order.appSkuId
      if (this.form.skuId === "") {
        this.$message.error("请选择需要关联的产品")
        return
      }
      if (this.form.num.trim() === "") {
        this.$message.error("请填写数量")
        return
      }

      //转换SKU
      await editSku(this.form)
      this.$message.success("保存成功")
      this.$emit("onClose")
    },
    handleSelectDesign() {
      this.showSelect = true
    },
    handleCloseDesign() {
      this.showSelect = false
    },

    handleChooseDesign({ designId, picUrl }) {
      this.currentOrderSku.designId = designId
      this.mainPic = picUrl
      this.form.skuId = ""
      this.getTargetItem(designId)
      this.showSelect = false
    },
  },
}
</script>

<style scoped lang="scss">
.pd10 {
  padding: 5px 10px;
  border-top: 1px solid #ebeef5;
}

.relateOrder {
  font-size: 12px;
}

.relateOrder .line {
  display: flex;
  height: 30px;
  align-items: center;
}

.relateOrder .line .title {
  width: 60px;
}

.table {
  border: 1px solid #ebeef5;
}

.table .top {
  display: flex;
  background: #f5f7fa;
  height: 36px;
  align-items: center;
}

.table .top .item {
  width: 50%;
  display: flex;
}

.table .top .item .left {
  width: 50px;
  text-align: center;
}

.table .top .item .right {
  width: 328px;
  text-align: center;
}

.table .table-list {
  display: flex;
  flex-wrap: wrap;
}

.table .table-list .item {
  width: 50%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  display: flex;
  justify-content: center;
}

.table .table-list .item:nth-child(2n) {
  border-right: 0;
}

.table .table-list .item:nth-last-child(2),
.table .table-list .item:last-child {
  border-bottom: 0;
}

.table .table-list .item .index {
  width: 40px;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
}

.table .table-list .item .content {
  display: flex;
  flex-direction: column;
  .left {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    border: 1px solid #ebeef5;
    margin-bottom: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    display: flex;
    flex-direction: column;

    .title {
      font-size: 14px;
      margin-bottom: 10px;
    }

    .list {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      width: 280px;
      height: 32px;

      .name {
        width: 85px;
      }

      .value {
        width: 100%;
      }
    }
  }
}
.sku-attr {
  overflow: hidden;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 32px 0 0;
    float: left;
    line-height: 37px;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
    width: calc(100% - 65px);
    line-height: 37px;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
}
.sku-size {
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  text-transform: capitalize;
  display: inline-block;
  margin: 0;
  min-width: 30px;
  overflow: hidden;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 7px;
  transition: all 0.5s ease-in-out;
  padding: 0 4px;
  margin: 0 12px 0px 0;

  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
  cursor: pointer;
  box-sizing: border-box;
}
.is-select {
  border: 2px solid #f25551;
}
.sku-price {
  font-size: 20px;
}
</style>
